// @flow
import React from 'react';
import { graphql, createRefetchContainer } from 'react-relay';
import { withRouter } from 'react-router-dom';
// UI
import { Table, TableBody, TableHeader, TableRow, TableHeaderColumn } from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
// Icon
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import NavigationRefresh from 'material-ui/svg-icons/av/replay';
// Pagination
import Pagination from '../controls/pagination/pagination';
import StreamListItem from './StreamListItem';
//
import ShowHiddenElement from '../showHiddenElement';
// style
import { containerHeader, styles, paperStyle } from '../../lib/styles';
import streamStyle from './stream-style';
import { table } from '../../lib/styles/table';
import '../ui/table.css';

type Props = {
    history: Object,
    location: Object,
    relay: Object,
    viewer: Object,
};

type State = {
    pageCursor: number,
    searchText: string,
    totalPages: number,
    currentQuery: ?string,
    states: ?Array<string>,
};

class StreamList extends React.Component<Props, State> {
    constructor(props: any) {
        super(props);
        const pageNumber = this.props.location.hash ? parseInt(this.props.location.hash.replace('#', ''), 10) : 1;
        this.state = {
            states: [],
            searchText: '',
            pageCursor: pageNumber,
            currentQuery: '',
            totalPages: Math.ceil(this.props.viewer.streams.totalCount / 10),
        };
    }

    componentWillReceiveProps(nextProps) {
        console.log(nextProps.viewer);
        this.setState({
            totalPages: Math.ceil(nextProps.viewer.streams.totalCount / 15),
        });
    }

    changePageUrl(path) {
        this.props.history.replace(`/streams?page#${path}`);
    }

    changePage(pageNumber) {
        const refetchVars = () => ({
            page: pageNumber,
            states: this.state.states,
            search: this.state.currentQuery ? this.state.currentQuery : null,
        });

        this.props.relay.refetch(refetchVars, null, () => {
            this.setState({ pageCursor: pageNumber });
        });
        this.changePageUrl(pageNumber);
    }

    changeHiddenShow(flag) {
        const stringStatus = flag ? ['deleted'] : ['published', 'draft', 'on_air', 'finished'];
        const vars = () => ({
            page: 1,
            states: stringStatus,
            search: this.state.currentQuery ? this.state.currentQuery : null,
        });

        this.props.relay.refetch(vars, null, () => {
            this.setState({
                pageCursor: 1,
                states: stringStatus,
                currentQuery: this.state.searchText.length > 0 ? this.state.searchText : null,
                searchText: '',
            });
        });
    }

    /**
     * Обработка данных из поисковой строки
     * @param e
     */
    searchFieldKeyPressed = (e: Object) => {
        if (e.charCode !== 13) {
            return;
        }

        const refetchVars = () => ({
            page: 1,
            search: this.state.searchText.length > 0 ? this.state.searchText : null,
        });

        this.props.relay.refetch(refetchVars, null, () => {
            this.setState({
                pageCursor: 1,
                currentQuery: this.state.searchText.length > 0 ? this.state.searchText : null,
                searchText: '',
            });
        });
    };

    /**
     * Рендер поискового поля
     * @returns {XML}
     */
    searchField = () => (
        <div className="header-filter--item header-filter--search header-filter--item_left">
            <TextField
                style={{
                    maxWidth: 222,
                    fontSize: 14,
                    marginLeft: 45,
                    height: 38,
                    paddingBottom: 5,
                    marginTop: 9,
                }}
                inputStyle={{ fontSize: 14 }}
                underlineStyle={{ marginTop: -2 }}
                hintStyle={{ bottom: 12 }}
                hintText="Поиск"
                value={this.state.searchText}
                onKeyPress={event => (this.searchFieldKeyPressed(event))}
                onChange={(e, v) => this.setState({ searchText: v })}
            />
        </div>
    );

    renderTable = () => (
        <Table className="table">
            <TableHeader
                displaySelectAll={false}
                adjustForCheckbox={false}
            >
                <TableRow style={{ border: 0 }}>
                    <TableHeaderColumn
                        style={{
                            ...streamStyle.columnDate,
                            ...table.th,
                            height: 53,
                        }}
                    >
                        Дата
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        style={{
                            ...streamStyle.columnTitle,
                            ...table.th,
                            height: 53,
                        }}
                    >
                        Заголовок
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        style={{
                            ...streamStyle.columnStatus,
                            ...table.th,
                            height: 53,
                        }}
                    >
                        Статус
                    </TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody
                showRowHover
                stripedRows
            >
                {this.renderStreamItem()}
            </TableBody>
        </Table>
    );

    renderStreamItem = () => this.props.viewer.streams.streams.map((stream) => (
        <StreamListItem
            key={stream.__id}
            stream={stream}
        />
    ));

    render() {
        return (
            <section>
                <Paper
                    style={{ ...paperStyle.mainItem, paddingTop: 5, paddingBottom: 0 }}
                >
                    <header
                        style={{
                            paddingTop: 5,
                            paddingBottom: 0,
                            ...containerHeader.header,
                            marginBottom: 5,
                            alignItems: 'none',
                        }}
                    >
                        <h3 style={{ ...styles.headerTitle, marginTop: 30 }}>Стримы</h3>
                        <div style={{ flexGrow: 1, alignSelf: 'center' }}>
                            {this.searchField()}
                        </div>
                        <div style={{ marginTop: 14, display: 'flex', alignItems: 'center' }}>
                            <ShowHiddenElement
                                onClick={(state) => {
                                    this.changeHiddenShow(state);
                                }}
                            />
                            <FlatButton
                                label="Обновить"
                                style={{ ...styles.headerButton, marginRight: -22 }}
                                primary
                                icon={<NavigationRefresh />}
                                onClick={() => { window.location = window.location; }}
                            />
                            <FlatButton
                                label="Создать стрим"
                                style={styles.headerButton}
                                primary
                                icon={<ContentAdd />}
                                onClick={() => this.props.history.push('/stream/new')}
                            />
                        </div>
                    </header>
                    <div style={{ margin: '50px -20px 0' }} >
                        {this.renderTable()}
                    </div>
                </Paper>
                <footer style={{ width: '100%', padding: '9px 0' }}>
                    <Pagination
                        totalPage={this.state.totalPages}
                        currentPage={this.state.pageCursor}
                        changePage={number => (this.changePage(number))}
                    />
                </footer>
            </section>
        );
    }
}

export default withRouter(createRefetchContainer(
    StreamList,
    graphql`
        fragment StreamList_viewer on Viewer @argumentDefinitions(
            page: {type:"Int!",},
            search: {type:"String",},
            states: {type:"[String]",},
        ) {
            streams: streamsPaginate(pageSize: 10, page: $page, search: $search, states: $states) {
                totalCount,
                streams {
                    ...StreamListItem_stream
                }
            },
        },
    `,
    graphql`
        query StreamList_Refetch_Query (
        $page: Int!,
        $search: String,
        $states: [String],
        ) {
            viewer {
                ...StreamList_viewer @arguments (page: $page, search: $search, states: $states)
            }
        }`,
));



// WEBPACK FOOTER //
// src/components/streams/StreamList.js